var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPipeLength(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "PIPE_LENGHT",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #PIPE_LENGHT .cls-1, #PIPE_LENGHT .cls-3 {\n        fill: #f5f5f5;\n      }\n\n      #PIPE_LENGHT .cls-2 {\n        fill: #c5d75d;\n      }\n\n      #PIPE_LENGHT .cls-3 {\n        stroke: #052334;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1177.817 -523.68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_440",
    "data-name": "Pfad 440",
    className: "cls-1",
    d: "M1202.434,535.227a.482.482,0,0,0-.225-.061h-17.8c-1.424,0-2.5,1.935-2.5,4.5s1.076,4.5,2.5,4.5h17.668a1.6,1.6,0,0,0,.166.028c1.425,0,2.5-1.934,2.5-4.5C1204.743,537.247,1203.761,535.4,1202.434,535.227Zm-.191,7.967h0a.408.408,0,0,0-.067-.023,1.2,1.2,0,0,1-.751-.619c-.014-.023-.028-.052-.042-.076a3.4,3.4,0,0,1-.168-.32c-.044-.1-.082-.207-.121-.316-.021-.059-.045-.113-.065-.175-.051-.164-.1-.34-.135-.524,0-.021-.01-.038-.014-.059-.04-.2-.07-.4-.093-.617,0-.017-.005-.031-.006-.048-.023-.232-.036-.473-.036-.723s.013-.483.035-.711c.009-.087.025-.166.036-.25.018-.135.034-.271.059-.4s.058-.242.089-.359c.019-.07.034-.145.054-.211a4.484,4.484,0,0,1,.163-.444c.006-.014.011-.03.017-.044.267-.609.618-.993.958-1.054.011,0,.024-.011.037-.015a.49.49,0,0,1,.052-.014c.708,0,1.5,1.5,1.5,3.5S1202.951,543.194,1202.243,543.194Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_441",
    "data-name": "Pfad 441",
    className: "cls-2",
    d: "M1184.409,543.166c-.708,0-1.5-1.5-1.5-3.5s.792-3.5,1.5-3.5h16.265a3.988,3.988,0,0,0-.379.676l-.013.03a5.508,5.508,0,0,0-.266.758c-.01.033-.02.065-.029.1a7.075,7.075,0,0,0-.154.791c-.008.055-.02.107-.027.163a8.416,8.416,0,0,0-.063,1.011,8.753,8.753,0,0,0,.059.991c.009.072.024.136.034.206.036.248.079.489.135.716.015.059.034.112.05.17a5.813,5.813,0,0,0,.223.656c.016.038.034.074.05.111a4.279,4.279,0,0,0,.32.591c.006.009.011.022.017.031Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_442",
    "data-name": "Pfad 442",
    className: "cls-1",
    d: "M1193.817,525.68a14,14,0,1,1-14,14,14.016,14.016,0,0,1,14-14m0-2a16,16,0,1,0,16,16,16,16,0,0,0-16-16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1612",
    "data-name": "Rechteck 1612",
    className: "cls-3",
    width: 13.89,
    height: 0.5,
    transform: "translate(1184.644 541.931)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipeLength);
export default __webpack_public_path__ + "static/media/pipe-length.6ca19675a0d25f1f11dce0607f48a510.svg";
export { ForwardRef as ReactComponent };